import { gql, TypedDocumentNode } from '@apollo/client';

import {
  AccessActions,
  AccessActionsInput,
  PoliciesConnection,
  PoliciesConnectionInput,
  Policy,
  PolicyCreateInput,
  PolicyUpdateInput,
} from '@atom/types/policy';

export const BASE_POLICY = gql`
  fragment BasePolicy on Policy {
    id
    subjectType
    subjectId
    action
    resource
    grant {
      type
      ids
    }
    grants {
      id
      name
    }
    createdBy {
      id
      firstName
      lastName
      email
    }
    createdDate
    updatedBy {
      id
      firstName
      lastName
      email
    }
    updatedDate
  }
`;

export const GET_POLICIES_FOR_VALIDATION: TypedDocumentNode<
  { policies: PoliciesConnection },
  { input: PoliciesConnectionInput }
> = gql`
  query policies($input: PoliciesConnectionInput!) {
    policies(input: $input) {
      totalCount
      policies {
        id
        subjectType
        subjectId
        action
        resource
        grant {
          type
          ids
        }
        grants {
          id
          name
        }
      }
    }
  }
`;

export const BULK_CREATE_POLICIES: TypedDocumentNode<
  { policiesCreate: Policy[] },
  { input: PolicyCreateInput[] }
> = gql`
  mutation policiesCreate($input: [PolicyCreateInput!]!) {
    policiesCreate(input: $input) {
      ...BasePolicy
    }
  }
  ${BASE_POLICY}
`;

export const UPDATE_POLICY: TypedDocumentNode<
  { policyUpdate: Policy },
  { input: PolicyUpdateInput }
> = gql`
  mutation policyUpdate($input: PolicyUpdateInput!) {
    policyUpdate(input: $input) {
      ...BasePolicy
    }
  }
  ${BASE_POLICY}
`;

export const DELETE_POLICY: TypedDocumentNode<
  { policyDelete: boolean },
  { id: string }
> = gql`
  mutation deletePolicy($id: ID!) {
    policyDelete(id: $id)
  }
`;

export const GET_ACCESS_ACTIONS: TypedDocumentNode<
  { accessActions: AccessActions },
  { input: AccessActionsInput }
> = gql`
  query accessActions($input: AccessActionsInput!) {
    accessActions(input: $input) {
      actions
    }
  }
`;
